<template>
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g stroke-width="2" fill="none">
            <ellipse cx="16" cy="16" rx="13" ry="6" :style="{ stroke: 'var(--ui-info)' }" transform="rotate(0 16 16)" />
            <ellipse cx="16" cy="16" rx="13" ry="6" :style="{ stroke: 'var(--ui-success)' }" transform="rotate(60 16 16)" />
            <ellipse cx="16" cy="16" rx="13" ry="6" :style="{ stroke: 'var(--ui-secondary)' }" transform="rotate(120 16 16)" />
        </g>
        <circle cx="16" cy="16" r="3" :style="{ fill: 'var(--ui-success)' }" />
    </svg>
</template>
